export const SubmitErrorComponent = (props: any) => (
   <p className="formManagerStatus">{props.error}</p>
);
